export const STALE_CHUNK_RELOAD_KEY = 'build-guard:chunk-reload'

export function isStaleChunkError(message: string, source?: string): boolean {
  const combined = `${message} ${source ?? ''}`.toLowerCase()
  return (
    combined.includes('loading chunk') ||
    combined.includes('chunkloaderror') ||
    combined.includes("reading 'call'") ||
    (combined.includes('element type is invalid') &&
      combined.includes('undefined')) ||
    combined.includes('/_next/static/')
  )
}

export function isStaleChunkErrorFromError(error: Error): boolean {
  return isStaleChunkError(error.message, error.stack)
}

export function isBuildGuardEnabled(): boolean {
  if (process.env.NODE_ENV === 'production') return true
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).has('debug-build-guard')
}

export function clearStaleChunkReloadGuard(): void {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY)
}

/** Returns true when a reload was initiated. */
export function reloadOnceForStaleChunk(): boolean {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return false
  }
  if (sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) return false
  sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, '1')
  console.warn('New deployment detected. Reloading app assets...')
  window.location.reload()
  return true
}

export function handleWindowError(event: ErrorEvent): void {
  if (isStaleChunkError(event.message || '', event.filename || '')) {
    reloadOnceForStaleChunk()
  }
}

export function handleUnhandledRejection(event: PromiseRejectionEvent): void {
  const reason = event.reason
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : ''
  const source =
    reason instanceof Error
      ? reason.stack || ''
      : typeof reason === 'object' && reason !== null && 'stack' in reason
        ? String((reason as { stack?: string }).stack ?? '')
        : ''
  if (isStaleChunkError(message, source)) {
    reloadOnceForStaleChunk()
  }
}
